import React from "react";
import { RotatingLines } from "react-loader-spinner";

interface IProps {
	title?: string;
}

const Loading: React.FC<IProps> = ({ title }) => {
	return (
		<div
			style={{
				padding: "10px 40px",
				width: "100%",
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
				justifyContent: "center",
			}}
		>
			<div
				style={{
					fontSize: "1.2rem",
					fontWeight: "bold",
					textAlign: "center",
				}}
			>{`Carregando ${title}...`}</div>
			<div
				style={{
					width: "fit-content",
				}}
			>
				<RotatingLines
					strokeColor="#63b8cd"
					strokeWidth="5"
					animationDuration="0.75"
					width="64"
					visible={true}
				/>
			</div>
		</div>
	);
};

export default Loading;
